module.exports = __webpack_public_path__ + "img/faspay.64ca818d.png";